export default __webpack_public_path__ + "static/media/Strangler's Bracers of the Silent Kill.716e2a67.jpg";